'use client';

import { getPlantCounts as getPlantCountsUtil } from '@modules/garden-planner/business_logic';
import { useGardenPlannerContext } from '@modules/garden-planner/context/garden_planner_context';
import {
  hasPlantsInGarden as hasPlantsInGardenUtil,
  getFreeCellCount,
  groupPlantCountsByCategory,
} from '@modules/garden-planner/garden_summary/business_logic';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface GardenSummaryContainerProps {
  views: GardenPlannerViews;
}

export function GardenSummaryContainer({ views }: GardenSummaryContainerProps) {
  const { garden, plants } = useGardenPlannerContext();
  const { GardenSummary } = views;

  const plantCounts = getPlantCountsUtil(plants, garden.plants);
  const plantGroups = groupPlantCountsByCategory(plantCounts, plants);
  const hasPlantsInGarden = hasPlantsInGardenUtil(plantCounts);
  const totalPlanted = garden.plants.length;
  const freeSpots = getFreeCellCount(garden);

  return (
    <GardenSummary
      plantGroups={plantGroups}
      hasPlantsInGarden={hasPlantsInGarden}
      totalPlanted={totalPlanted}
      freeSpots={freeSpots}
    />
  );
}
